// Per-store endpoints passed in via data-* attributes on this script tag,
// sourced from shop metafields (custom.ip_geolocation_url / custom.customer_cases_proxy_url).
const endpointConfig = document.currentScript?.dataset ?? {};

document.addEventListener('DOMContentLoaded', () => {
  // Only run on the contact form page
  const isContactForm = window.location.pathname.includes('/pages/contact-form');
  if (!isContactForm) return;

  // Removes the CORS console error when developing locally.
  const isLocalHost = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
  if (isLocalHost) return;

  // Exit when no geolocation url provided
  if (!endpointConfig.ipGeolocationUrl) return;

  fetch(endpointConfig.ipGeolocationUrl)
    .then((res) => res.json())
    .then((data) => {
      document.querySelectorAll('.js-country').forEach((el) => (el.value = data.country_code));
      document.querySelectorAll('.js-state').forEach((el) => (el.value = data.region_code));
      document.querySelectorAll('.js-city').forEach((el) => (el.value = data.city));
      document.querySelectorAll('.js-ip').forEach((el) => (el.value = data.ip));
    })
    .catch((err) => console.error(err));
});

function setupAccordion() {
  const isMobile = window.innerWidth <= 1023;
  const headings = document.querySelectorAll('.footer-block--menu .footer-block__heading');

  // Clear previous event listeners by cloning
  headings.forEach((heading) => {
    const newHeading = heading.cloneNode(true);
    heading.parentNode.replaceChild(newHeading, heading);
  });

  if (isMobile) {
    const updatedHeadings = document.querySelectorAll('.footer-block--menu .footer-block__heading');
    updatedHeadings.forEach((heading) => {
      const content = heading.nextElementSibling;
      if (content) {
        content.style.maxHeight = '0px';
      }

      heading.addEventListener('click', () => {
        const isActive = heading.classList.contains('active');

        if (isActive) {
          // Collapse
          heading.classList.remove('active');
          if (content) content.style.maxHeight = '0px';
        } else {
          // Collapse any other open accordion
          updatedHeadings.forEach((h) => {
            if (h !== heading && h.classList.contains('active')) {
              h.classList.remove('active');
              const c = h.nextElementSibling;
              if (c) c.style.maxHeight = '0px';
            }
          });
          // Expand
          heading.classList.add('active');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  } else {
    // Clean all on desktop
    const allHeadings = document.querySelectorAll('.footer-block--menu .footer-block__heading');
    allHeadings.forEach((h) => {
      h.classList.remove('active');
      const c = h.nextElementSibling;
      if (c) c.style.maxHeight = '';
    });
  }
}

// Initial load
document.addEventListener('DOMContentLoaded', setupAccordion);

// On window resize
window.addEventListener('resize', setupAccordion);

document.addEventListener('DOMContentLoaded', function () {
  const openCartBtn = document.querySelector('.open-cart');
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (openCartBtn && cartIcon) {
    openCartBtn.addEventListener('click', function () {
      cartIcon.click(); // Trigger original cart drawer
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const WRAPPER_SELECTOR = '#contactUsAccordion'; // change only if your wrapper has a different ID
  const MOBILE_MAX = 1023;
  const container = document.querySelector(WRAPPER_SELECTOR) || document.body;

  // helpers
  const getCollapses = () => Array.from(container.querySelectorAll('.collapse'));
  const getTogglesFor = (targetEl) => {
    if (!targetEl.id) return [];
    const id = '#' + targetEl.id;
    return Array.from(container.querySelectorAll(`[data-target="${id}"]`));
  };

  const openCollapse = (el) => {
    el.classList.add('show');
    el.setAttribute('aria-hidden', 'false');
    getTogglesFor(el).forEach((t) => {
      t.classList.remove('collapsed');
      t.setAttribute('aria-expanded', 'true');
    });
  };
  const closeCollapse = (el) => {
    el.classList.remove('show');
    el.setAttribute('aria-hidden', 'true');
    getTogglesFor(el).forEach((t) => {
      t.classList.add('collapsed');
      t.setAttribute('aria-expanded', 'false');
    });
  };
  const closeAllExcept = (exceptEl) => {
    getCollapses().forEach((c) => {
      if (c === exceptEl) return;
      if (c.classList.contains('show')) closeCollapse(c);
    });
  };

  // set modes
  function setMobileMode() {
    getCollapses().forEach((c) => {
      if (!c.classList.contains('collapse')) c.classList.add('collapse'); // ensure collapse class exists
      // collapse by default on mobile
      c.classList.remove('show');
      c.setAttribute('aria-hidden', 'true');
      getTogglesFor(c).forEach((t) => {
        t.classList.add('collapsed');
        t.setAttribute('aria-expanded', 'false');
      });
    });
  }
  function setDesktopMode() {
    getCollapses().forEach((c) => {
      c.classList.add('show'); // show everything on desktop
      c.setAttribute('aria-hidden', 'false');
      getTogglesFor(c).forEach((t) => {
        t.classList.remove('collapsed');
        t.setAttribute('aria-expanded', 'true');
      });
    });
  }

  // initialize & responsive handling (debounced)
  let resizeTimeout = null;
  function applyMode() {
    if (window.innerWidth <= MOBILE_MAX) setMobileMode();
    else setDesktopMode();
  }
  applyMode();
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(applyMode, 120);
  });

  // single delegated click listener for all toggles inside container
  container.addEventListener(
    'click',
    function (e) {
      // find nearest ancestor with the toggle attribute
      const toggle = e.target.closest('[data-toggle="collapse"]');
      if (!toggle || !container.contains(toggle)) return;

      // only active on mobile widths
      if (window.innerWidth > MOBILE_MAX) return;

      e.preventDefault();
      const targetSelector = toggle.getAttribute('data-target') || toggle.dataset.target;
      if (!targetSelector) return;
      const target = document.querySelector(targetSelector);
      if (!target) return;

      const isOpen = target.classList.contains('show');
      if (isOpen) {
        closeCollapse(target);
      } else {
        // open this and close others
        closeAllExcept(target);
        openCollapse(target);
        // optionally, scroll into view on very small screens:
        // target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    false,
  );

  // keyboard accessibility for toggles
  container.querySelectorAll('[data-toggle="collapse"]').forEach((el) => {
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    el.addEventListener('keydown', function (ev) {
      if (window.innerWidth > MOBILE_MAX) return;
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault();
        el.click();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('.form-control');

  inputs.forEach(function (input) {
    const formGroup = input.closest('.form-group');

    // For text inputs
    input.addEventListener('input', function () {
      if (input.value.trim() !== '') {
        formGroup.classList.add('input-active');
      } else {
        formGroup.classList.remove('input-active');
      }
    });

    // For select and all inputs on focus/click
    input.addEventListener('focus', function () {
      formGroup.classList.add('input-active');
    });

    input.addEventListener('blur', function () {
      if (input.value.trim() === '') {
        formGroup.classList.remove('input-active');
      }
    });
  });

  // browser details
  var browserDetailFields = document.querySelectorAll('textarea.browser-details');
  var userAgent = navigator.userAgent;
  // Fill each textarea with the user agent
  browserDetailFields.forEach(function (field) {
    field.value = userAgent;
  });

  // Dynamic height for textarea
  const textareas = document.querySelectorAll('.form-control-textarea');

  textareas.forEach(function (textarea) {
    const baseHeight = 40; // CSS initial height
    const lineHeight = 24;

    // Set initial height
    textarea.style.height = baseHeight + 'px';

    textarea.addEventListener('input', function () {
      const value = textarea.value;

      if (value.trim() === '') {
        textarea.style.height = baseHeight + 'px';
        return;
      }

      // Count how many lines based on actual line breaks
      const numberOfLines = value.split('\n').length;

      // Final height = 40px + 24px * (lines - 1)
      const extraLines = Math.max(0, numberOfLines - 1);
      const newHeight = baseHeight + extraLines * lineHeight;

      textarea.style.height = newHeight + 'px';
    });
  });

  // Convert file to Base64
  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]); // only Base64
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
  // Get all forms
  const forms = document.querySelectorAll('.js-contact-us-form');

  forms.forEach(function (form) {
    // Batch Number field handling
    const probTypeSelect = form.querySelector('.problem-type-js');
    const batchGroup = form.querySelector('.batch-num')?.closest('.form-group');

    if (batchGroup && probTypeSelect) {
      // Hide initially
      batchGroup.style.display = 'none';
      batchGroup.classList.remove('required');

      // Toggle on change
      probTypeSelect.addEventListener('change', function () {
        if (this.value === 'Damaged Products') {
          batchGroup.style.display = '';
          batchGroup.classList.add('required');
        } else {
          batchGroup.style.display = 'none';
          batchGroup.classList.remove('required');
          const batchInput = batchGroup.querySelector('.batch-num');
          batchInput.value = '';

          // 🔹 Clear error state if any
          batchGroup.classList.remove('has-error');
          const existingError = batchGroup.querySelector('.error-message');
          if (existingError) existingError.remove();
        }

        // Update hidden dropdown
        // if (mapping[this.value]) {
        //   recordType.value = mapping[this.value];
        // } else {
        //   recordType.value = ""; // reset
        // }
      });
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      // Combine first + last name for THIS form only
      const firstName = form.querySelector('#firstName')?.value.trim() || '';
      const lastName = form.querySelector('#lastName')?.value.trim() || '';
      const nameField = form.querySelector('#name');
      if (nameField) {
        nameField.value = `${firstName} ${lastName}`.trim();
      }

      let isValid = true;

      const requiredFields = form.querySelectorAll('.required .form-control');
      const requiredCheckboxes = form.querySelectorAll('.required input[type="checkbox"]');

      requiredFields.forEach(function (field) {
        const formGroup = field.closest('.form-group');

        // Remove any existing error
        formGroup.classList.remove('has-error');
        let existingError = formGroup.querySelector('.error-message');
        if (existingError) existingError.remove();

        const value = field.value.trim();

        if (value === '') {
          showError(field, field.dataset.requiredMessage || 'This field is required');
          isValid = false;
        }

        // Special case for email field
        if (field.classList.contains('email-input') && value !== '') {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            showError(field, 'Please enter a valid e-mail');
            isValid = false;
          }
        }

        // Special case for Order Number min length check
        if (field.classList.contains('order-number') && value !== '') {
          if (value.length < 4 || value.length > 50) {
            showError(field, 'Length must be between 4-50 characters.');
            isValid = false;
          }
        }

        // Special case for date field in yyyy-mm-dd format
        if (field.classList.contains('date-input') && value !== '') {
          const dateRegex = /^[1-2]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
          if (!dateRegex.test(value)) {
            showError(field, 'Please enter a date in the format yyyy-mm-dd');
            isValid = false;
          }
        }
      });

      // 🔹 Validate checkboxes
      requiredCheckboxes.forEach(function (checkbox) {
        const formGroup = checkbox.closest('.form-group');

        // Remove existing errors
        formGroup.classList.remove('has-error');
        let existingError = formGroup.querySelector('.error-message');
        if (existingError) existingError.remove();

        if (!checkbox.checked) {
          showError(checkbox, 'Please check this box if you want to proceed.');
          isValid = false;
        }
      });

      // 🔹 NEW: Validate attachments (max 2MB each)
      const maxSize = 2 * 1024 * 1024; // 2 MB
      const attachmentInputs = form.querySelectorAll('input[type="file"]');
      attachmentInputs.forEach(function (fileInput) {
        if (fileInput.files.length > 0) {
          const file = fileInput.files[0];
          if (file.size > maxSize) {
            showError(fileInput, 'File size must not exceed 2MB.');
            isValid = false;
          }
        }
      });

      if (!isValid) {
        e.preventDefault();
        return;
      }

      // If this is a support form, send data to API
      if (form.dataset.supportForm !== undefined) {
        try {
          // First, read the hidden tokens inserted by Liquid
          const cache_time = form.querySelector('#cache_time').value;
          const current_time_elem = form.querySelector('#current_time');
          const encoded_string_elem = form.querySelector('#encoded_string');

          const current_time = current_time_elem ? current_time_elem.value : null;
          const encoded_string = encoded_string_elem ? encoded_string_elem.value : null;

          if (!current_time || !encoded_string) {
            console.error('Missing current_time or encoded_string hidden fields. Aborting submit.');
            alert('Unable to submit form: security token missing.');
            return;
          }

          const formData = new FormData(form);

          // Convert form fields to plain object
          const plainData = Object.fromEntries(formData.entries());

          // Handle attachments
          const attachments = [];
          const fileInputs = form.querySelectorAll('input[type="file"]');
          for (const input of fileInputs) {
            if (input.files.length > 0) {
              const file = input.files[0];
              const base64 = await fileToBase64(file);
              attachments.push({
                filename: file.name,
                content_type: file.type,
                data: base64,
              });
            }
          }

          // Add attachments array to JSON
          plainData.attachments = attachments;

          if (!endpointConfig.proxyUrl) {
            console.warn(
              '[custom.js] Missing proxy URL (shop metafield custom.customer_cases_proxy_url). Aborting submit.',
            );
            return;
          }

          // Send JSON
          const response = await fetch(endpointConfig.proxyUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              current_time: current_time,
              cache_time: cache_time,
              encoded_string: encoded_string,
            },
            body: JSON.stringify(plainData),
          });

          if (response.ok) {
            // Determine market prefix from the current path (expects paths like /en-us/... )
            const pathSegments = window.location.pathname.split('/').filter(Boolean); // removes empty parts
            const firstSeg = pathSegments.length ? pathSegments[0] : '';
            // Heuristic: treat first segment as market if it contains a hyphen (e.g. en-us, en-ca)
            const isMarketPrefix = typeof firstSeg === 'string' && firstSeg.indexOf('-') > -1;
            const thankYouPath = isMarketPrefix
              ? `/${firstSeg}/pages/contact-us-thankyou`
              : `/pages/contact-us-thankyou`;

            // Use assign to redirect (keeps history). Use origin + path to be explicit.
            const redirectUrl = window.location.origin + thankYouPath;
            window.location.assign(redirectUrl);
          } else {
            const text = await response.text();
            console.error('API Error:', text);
            alert('Something went wrong. Please try again.');
          }
        } catch (error) {
          console.error('Network Error:', error);
        }
      } else {
        form.submit();
      }
    });
  });

  function showError(field, message) {
    const formGroup = field.closest('.form-group');
    formGroup.classList.add('has-error');

    const error = document.createElement('div');
    error.className = 'error-message';
    error.textContent = message;

    // Insert after the input/textarea
    field.parentNode.appendChild(error);
  }

  // Get the URL parameter "target" for contact page
  const urlParams = new URLSearchParams(window.location.search);
  const target = urlParams.get('target'); // e.g., "Website"

  // Step 1: Set the subject field from the H1 title
  // const h1Title = document.querySelector('.header-contactUs-Form');
  // const subjectField = document.getElementById('subject');
  // if (h1Title && subjectField) {
  //   subjectField.value = h1Title.textContent.trim();
  // }

  // === Attachment UI Handling ===
  document.querySelectorAll('.form-group_attachment').forEach(function (group) {
    const fileInput = group.querySelector('input[type="file"]');
    const resultText = group.querySelector('.js-result-change');
    const resetButton = group.querySelector('.js-reset-attachment');
    const label = group.querySelector('label.form-control-label');

    if (!fileInput || !resultText || !resetButton || !label) return;

    fileInput.addEventListener('change', function () {
      if (fileInput.files.length > 0) {
        const fileName = fileInput.files[0].name;
        resultText.textContent = fileName;
        resultText.classList.remove('d-none');
        resetButton.classList.remove('d-none');
        label.classList.add('d-none');
      } else {
        resetAttachment();
      }
    });

    resetButton.addEventListener('click', function () {
      resetAttachment();
    });

    function resetAttachment() {
      fileInput.value = '';
      resultText.textContent = '';
      resultText.classList.add('d-none');
      resetButton.classList.add('d-none');
      label.classList.remove('d-none');
    }
  });
});

document.querySelectorAll('.play-button').forEach((button) => {
  button.addEventListener('click', function () {
    const wrapper = this.closest('.video-wrapper');

    // Default to desktop video
    let video = wrapper.querySelector('video.desktop-video');

    // If mobile video is available and screen size is mobile, use it
    if (
      wrapper.classList.contains('has-mobile-video') &&
      window.matchMedia('(max-width: 750px)').matches
    ) {
      const mobileVideo = wrapper.querySelector('video.mobile-video');
      if (mobileVideo) {
        video = mobileVideo;
      }
    }

    if (!video) return; // Fallback safety

    video.controls = true;
    video.play();
    wrapper.classList.add('video-playing');
    this.style.display = 'none';

    // When video ends
    video.addEventListener(
      'ended',
      () => {
        wrapper.classList.remove('video-playing');
        video.controls = false;
        video.currentTime = 0;
        video.pause();

        // Re-show play button
        this.style.display = 'block';

        // Reset poster image if needed
        const poster = video.getAttribute('poster');
        if (poster) {
          video.load(); // Reload to show poster
        }
      },
      { once: true },
    ); // Avoid multiple triggers
  });
});

// join us page dropdown
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const dropdown = document.querySelector('.page-selector .custom-select');
    if (!dropdown) return;

    dropdown.addEventListener('change', function () {
      const selectedValue = this.value;
      if (!selectedValue) return;

      // Show loader before redirect
      const preloader = document.createElement('div');
      preloader.className = 'preloader';
      document.body.appendChild(preloader);

      setTimeout(() => {
        window.location.href = selectedValue;
      }, 300);
    });
  });
})();

/***********************/
/* Join Us Redirection */
/***********************/
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Ensure user is on Join Us page and links are available
    const isJoinUsPage = window.location.pathname.includes('/pages/join-us');
    if (!isJoinUsPage) return;

    const targetUrl = 'https://deciem-prod-atlanta.us.careers.hr';
    const joinUsLinks = document.querySelectorAll(`a[href^="${targetUrl}"]`);
    if (!joinUsLinks.length) return;

    // Constants
    const supportedCountries = [
      // Add location for US only
      {
        code: 'US',
        name: 'United States',
      },
    ];

    // Helpers
    function getSupportedCountry() {
      const countryCode =
        window.location.pathname?.split('/')?.[1]?.split('-')?.pop()?.toUpperCase() || '';
      return supportedCountries.find((c) => c.code === countryCode);
    }

    // Main
    // 1. Check if country is supported
    const supportedCountry = getSupportedCountry();
    if (!supportedCountry) return;

    // 2. Swap out original job board links to point to ELC Job Board instead
    const elcJobBoardUrl = 'https://elcompanies.eightfold.ai/careers';
    const newUrl = new URL(elcJobBoardUrl);
    newUrl.searchParams.set('location', supportedCountry.name); // ELC Job Board uses full country name in search param, not country code
    newUrl.searchParams.set('filter_brand', 'deciem'); // Pre-filter for Deciem

    for (const joinUsLink of joinUsLinks) {
      joinUsLink.href = newUrl.toString();
    }
  });
})();

/******************/
/* Quantity Guard */
/******************/
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    /**
     * Prevents the "-" (minus) button from removing items, matching previous store's expected behaviour.
     * If Quantity is 1, the decrement action is blocked.
     * Must be placed before any other functions listening for the quantity input click.
     */
    function initQuantityGuard() {
      document.body.addEventListener(
        'click',
        function (event) {
          // Get quantity button element
          const button = event.target.closest('.quantity__button');
          if (!button) return;

          // Only act on 'minus' button
          if (button.name !== 'minus') return;

          // Get input element
          const input = button.parentElement.querySelector('.quantity__input');
          if (!input) return;

          // Block decrement if quantity is 1
          const currentValue = parseInt(input.value);
          if (currentValue <= 1) {
            // Stop browser and theme from seeing the click
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
          }
        },
        { capture: true },
      );
    }

    // Initialize
    initQuantityGuard();
  });
})();
